const KEY = 'ec2mod:checked-account-ids:v1';

export function readScanCache(storage: Pick<Storage, 'getItem'>): string[] {
  const raw = storage.getItem(KEY);
  if (!raw) return [];
  const ids: unknown = JSON.parse(raw);
  if (!Array.isArray(ids) || ids.some(id => typeof id !== 'string' || !id || id.length > 128)) {
    throw new Error('Saved scan history is invalid');
  }
  return [...new Set(ids as string[])];
}

export function rememberScannedIds(storage: Pick<Storage, 'getItem' | 'setItem'>, ids: string[]): number {
  const merged = [...new Set([...readScanCache(storage), ...ids])];
  storage.setItem(KEY, JSON.stringify(merged));
  return merged.length;
}
